import { Accordion, Grid } from '@mantine/core';
import { useAccordionStyles } from '../../styles';
import styled from '@emotion/styled';

const StyledGrid = styled(Grid)`
  padding: 5px 16px 16px;
`;

const StyledLabel = styled.span`
  margin-left: 5px;
`;

const StyledDivider = styled.div`
  margin-bottom: 10px;
`;

const Overview = ({ er_id, sku, sku_description, sales_org, country }) => {
  const { classes } = useAccordionStyles();

  return (
    <Accordion
      iconPosition='right'
      defaultValue={'0'}
      classNames={classes}
      className={classes.root}
    >
      <Accordion.Item className='project-name' value={'0'}>
        <Accordion.Control>{er_id} </Accordion.Control>
        <Accordion.Panel>
          <StyledGrid>
            <Grid.Col span={2}>
              <b>SKU No.:</b>
              <StyledLabel>{sku ? sku : 'N/A'}</StyledLabel>
            </Grid.Col>

            <Grid.Col span={2}>
              <b>SKU Desc.:</b>
              <StyledLabel>{sku_description ? sku_description : 'N/A'}</StyledLabel>
            </Grid.Col>

            <Grid.Col span={2}>
              <b>Sales Organisation:</b>
              <StyledLabel>{sales_org ? sales_org : 'N/A'}</StyledLabel>
            </Grid.Col>

            <Grid.Col span={2}>
              <b>Country :</b>
              <StyledLabel>{country ? country : 'N/A'}</StyledLabel>
            </Grid.Col>
          </StyledGrid>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default Overview;
